import { render, staticRenderFns } from "./attribute_value_edit.vue?vue&type=template&id=4071d9fb&scoped=true"
import script from "./attribute_value_edit.vue?vue&type=script&lang=js"
export * from "./attribute_value_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071d9fb",
  null
  
)

export default component.exports